import React from "react";
import { history } from "../../helper/history.js";
import { AzureStorage } from "../../helper/azureStorage.js";
import ContentWrapper from "../../components/common/ContentWrapper.js";
import classNames from "classnames";
import Card from "../../components/common/Card.js";
import CardBody from "../../components/common/CardBody.js";
import CardToolbar from "../../components/common/CardToolbar.js";
import CardTitle from "../../components/common/QuestionCardTitle.js";
import FileUpload from "../../components/common/form/FileUpload.js";
import SubmissionFileUpload from "../../components/common/form/SubmissionFileUpload.js";
import CheckBox from "../../components/common/form/CheckBox.js";
import CheckBoxInline from "../../components/common/form/CheckBoxInline.js";
import RadioInline from '../../components/common/form/RadioInline.js';
import Radio from '../../components/common/form/Radio.js';
import { ExamTimer } from "./ExamTimer.js";
import SubmitModal from "react-bootstrap/Modal";
import Modal from "../../components/common/modal/Modal.js";
import ModalBody from "../../components/common/modal/ModalBody.js";
import ModalFooter from "../../components/common/modal/ModalFooter.js";
import QuestionButton from "../../components/common/form/QuestionButton.js";
import { Button } from "@mui/material";
import { Editor } from "react-draft-wysiwyg";
import ViewEditor from "../../components/common/ViewEditor.js";
import { connect } from "react-redux";
import {
  convertFromRaw,
  convertToRaw,
  EditorState,
  ContentState
} from "draft-js";
import {
  finishTest,
  getAllQuestionContents,
  getAllAnswerContents,
  getTestQuestionContent,
  getCandidateAnswers,
  getAllCandidateAnswerContents,
  loadQuestions,
  loadAssessmentQuestions,
  submitAnswers,
  getAutoShuffleFlag,
  onSetMarks,
  refreshAssessmentStartPage
} from "../../actions/candidate/testActions.js";
import {
  saveMarks,
  finalizeGrade,
  finalizeAutoGrade
} from "../../actions/candidate/gradeActions.js";
import { questionMCQAnswerTypeConstants, questionTypeConstants } from "../../helper/constants.js";
import { namespace } from "../../helper/namespace.js";
import ExamviewButton from "../../components/common/form/ExamviewButton.js";
import Spinner from "../../components/Spinner3.js";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { getReport, restartExam } from '../../actions/candidate/examActions.js';
import { assessmentActions } from "../../actions/assessment/assessmentActions.js";
import "./Questions.css"
import PaperAutoGradeReport from "./PaperAutoGradeReport.js";
import PaperGradeReport from "./PaperGradeReport.js";
import config from '../../helper/config.js';
import { customerConstants } from "../../helper/constants.js";
import { store } from "../../helper/redux_store";
import { candidateService } from "../../service/settings/candidate/candidateService.js";
import { dropdownService } from "../../service/question/dropdownService.js";
import QuestionRenderer from "./QuestionRenderer";
import SubQuestionRenderer from "./SubQuestionRenderer.js";
import AssessmentInfoCard from "../assessment/components/AssessmentInfoCard.js";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import FeedbackAssessment from "../assessment/components/feedbacks/FeedbackAssessment.js";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle, cancelClass, confirmClass, isCMC
const customer = getCustomerFeatureFlag()
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    isCMC = false;
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor)",
      borderColor: "transparent",
      boxShadow: "none"
    }
    cancelClass = "btn-default"
    confirmClass = "btn-primary"
    break
  case customerConstants.EXO_CUSTOMER2:
    isCMC = true;
    closeBtnStyle = {
      color: "var(--maincolor-cmc)",
      backgroundColor: "#E5F5FF",
      borderColor: "transparent"
    }
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor-cmc)",
      borderColor: "transparent",
      boxShadow: "none"
    }
    break
  default:
    isCMC = false;
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor)",
      borderColor: "transparent",
      boxShadow: "none",
      textTransform: "Unset",
      fontFamily: "Inter"
    }
    cancelClass = "btn-default"
    confirmClass = "btn-primary"
    break
}


class PaperQuestions extends React.Component {
  // Returns the answer mode for a submission question (e.g., 'typed', 'file', 'hybrid')
  getsubmissionAnswerMode = (question) => {
    const explicitMode = this.state.submissionAnswerMode?.[question.question_id];
    if (explicitMode) return explicitMode;

    // If files exist, force UPLOAD
    if (this.state.answers?.[question.question_id]?.length > 0) {
      return "UPLOAD";
    }

    // If typed content exists
    if (question?.answer?.getCurrentContent?.()?.hasText?.()) {
      return "TYPED";
    }

    // Final fallback
    return "UPLOAD";
  };

  // Helper to check if submission mode is TYPED (backend code)
  isTypedMode = (mode) => {
    return mode === "TYPE";
  };

  // Utility to generate a random string
  _randomString(length, chars) {
    let mask = "";
    if (chars.indexOf("a") > -1) mask += "abcdefghijklmnopqrstuvwxyz";
    if (chars.indexOf("#") > -1) mask += "0123456789";
    let result = "";
    for (let i = length; i > 0; --i)
      result += mask[Math.floor(Math.random() * mask.length)];
    return result;
  }

  intervalID;

  constructor(props) {
    super(props);

    this.state = {
      errors: {},
      answers: {},
      getContent: true,
      questions: "",
      assessmentQuestions: "",
      currentQuestion: 0,
      viewAllQuestions: false,
      ans: EditorState.createEmpty(),
      needToRevise: 0,
      answeredNum: 0,
      submissionState: false,
      loadSubmissions: true,
      finishState: false,
      timeUp: false,
      submit: false,
      setAnswers: false,
      fileUpload: false,
      filesUploaded: [],
      answeredQuestions: [],
      subQuestionsIndexes: [],
      subQuestions: [],
      revisedQuestions: [],
      isConnected: window.navigator.onLine,
      auto_shuffle: false,
      isAllMCQs: true,
      renderGradeReport: null,
      examViewLoading: true,
      submitLoading: false,
      isSubmitModalVisible: false,
      remarksEditorState: EditorState.createEmpty(),
      highlightedQuestion: null,
      candidateGradeScales: [],
      activePartId: null,
      activeSectionId: null,
      currentQuestionIndex: null,
      partIds: null,
      groupedQuestions: {},
      is_restart: false,
      is_pause: false,
      pause_until: null,
      showRatingModal : false
    };

    this.onClickViewAllQuestions = this.onClickViewAllQuestions.bind(this);
    this.onSelectQus = this.onSelectQus.bind(this);
    this.onClickNext = this.onClickNext.bind(this);
    this.onClickPrevious = this.onClickPrevious.bind(this);
    this.onClickNextPart = this.onClickNextPart.bind(this);
    this.onClickPreviousPart = this.onClickPreviousPart.bind(this);
    this.onClickSave = this.onClickSave.bind(this);
    this.handleSubmitTest = this.handleSubmitTest.bind(this);
    this.makeEdit = this.makeEdit.bind(this);
    this.markAnswer = this.markAnswer.bind(this);
    this.markOneAnswer = this.markOneAnswer.bind(this);
    this.getSubmissionContent = this.getSubmissionContent.bind(this);
    this.deleteSubmissionContent = this.deleteSubmissionContent.bind(this);
    this.onDownloadAttachment = this.onDownloadAttachment.bind(this);
    this.autosaveTestState = this.autosaveTestState.bind(this);
    this.autoGradeMCQ = this.autoGradeMCQ.bind(this);
    this.generateGroupedQuestions = this.generateGroupedQuestions.bind(this);

    this.questionRefs = [];
    this.partRefs = {};
    this.sectionRefs = {};
    this.containerRef = React.createRef();
  }

  getAnswerParts(parsedAnswer) {
    let textPart = null;
    let fileParts = [];
    const isHybrid = Array.isArray(parsedAnswer) && parsedAnswer.length > 0 && parsedAnswer[0]?.part_type;

    if (isHybrid) {
      parsedAnswer.forEach((part) => {
        if (part.part_type === "text" && part.value) {
          textPart = part.value;
        }
        if (part.part_type === "file" && part.blob) {
          fileParts.push(part.blob);
        }
      });
    }

    return { textPart, fileParts, isHybrid };
  }

  setQuestionAnswer(ques, questionId, rawAnswer) {
    const categorizedQuestionIndex = ques.findIndex(
      (item) => item.question_id === questionId
    );

    if (categorizedQuestionIndex !== -1) {
      ques[categorizedQuestionIndex]["answer"] = EditorState.createWithContent(
        convertFromRaw(rawAnswer)
      );
    }
  }

  hasAnswerContent(parsedAnswer, textPart, fileParts) {
    let hasTypedContent = false;
    let hasFileContent = false;

    if (textPart?.blocks?.[0]?.text && textPart.blocks[0].text.trim() !== "") {
      hasTypedContent = true;
    }

    if (fileParts.length > 0) {
      hasFileContent = true;
    }

    if (
      !hasTypedContent &&
      parsedAnswer?.blocks?.[0]?.text &&
      parsedAnswer.blocks[0].text.trim() !== ""
    ) {
      hasTypedContent = true;
    }

    if (
      !hasFileContent &&
      Array.isArray(parsedAnswer) &&
      parsedAnswer.length > 0 &&
      !parsedAnswer[0]?.part_type
    ) {
      hasFileContent = true;
    }

    return hasTypedContent || hasFileContent;
  }

  buildTypedFileAnswer(typedAnswer, fileAnswers) {
    if (typedAnswer && (!fileAnswers || fileAnswers.length === 0)) {
      return typedAnswer;
    }

    if ((!typedAnswer || typedAnswer.length === 0) && fileAnswers.length > 0) {
      return fileAnswers;
    }

    if (typedAnswer && fileAnswers.length > 0) {
      let hybridAnswer = [];

      hybridAnswer.push({
        part_type: "text",
        value: typedAnswer,
      });

      fileAnswers.forEach((file) => {
        hybridAnswer.push({
          part_type: "file",
          blob: file,
        });
      });

      return hybridAnswer;
    }

    return [];
  }

  buildEmptyEditorAnswer() {
    let editorContent = [];
    let block = {
      blocks: [
        {
          key: this._randomString(5, "#a"),
          text: "",
          type: "unstyled",
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
        },
      ],
      entityMap: {},
    };
    editorContent.push(block);
    return editorContent[0];
  }

  // function to shuffle questions
  shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  onUnload = (e) => {
    this.autosaveTestState(true)
    // the method that will be used for both add and remove event
    e.preventDefault();
    //this.saveTestState();
    e.returnValue = "";
  };

  OfflineFunction = (e) => {
    window.alert(" You're offline!");
    this.setState({
      isConnected: false,
    });
  };

  OnlineFunction = (e) => {
    window.alert("Back Online!");
    this.setState({
      isConnected: true,
    });
  };

  async componentDidMount() {
    if (window.KTApp) window.KTApp.initComponents();
    this.setState({ getContent: false });
    // according to autoshuffle shuffles questions
    await this.props.getAutoShuffleFlag().then(async () => {
      let subQuestionsObject = {};
      this.props.questions.forEach((item) => {
        if (item.is_subquestion === "true") {
          subQuestionsObject[item.question_id] = item;
        }
      });
      let subQuestionsIndexes = this.props.questions.map((item, index) => item.is_subquestion === "true" ? index : null)
        .filter(index => index !== null);

      this.setState({
        subQuestions: subQuestionsObject,
        subQuestionsIndexes: subQuestionsIndexes,
      })
      if (this.props.auto_shuffle) {
        let shuffledQuestions = this.shuffleArray(this.props.questions);
        this.setState({
          questions: shuffledQuestions
        })
        await this.props.getAllQuestionContents({ questions: shuffledQuestions });
      }
      else {
        this.setState({
          questions: this.props.questions.filter(item => item.is_subquestion !== "true")
        })
        await this.props.getAllQuestionContents({ questions: this.props.questions });
      }
    });
    await this.props.loadAssessmentQuestions(this.props.assessment.assessment_id);
    this.setState({ assessmentQuestions: this.props.assessmentQuestions });
    await this.props.getAllAnswerContents({ questions: this.props.assessmentQuestions });
    if (!this.props.candidateAnswerContents?.length || !this.props.candidateAnswers?.length) {
      this.autosaveTestState()
    }
    this.intervalID = setInterval(
      this.autosaveTestState,
      config.examConfigs.autoSubmitInterval * 60 * 1000
    );
    window.addEventListener("beforeunload", this.onUnload);
    window.addEventListener("online", this.OnlineFunction);
    window.addEventListener("offline", this.OfflineFunction);
    await this.getAllCandidateGradeScales();
    this.questionRefs = this.state.questions.map(() => React.createRef());

    if (
      this.props.sections?.length > 0 &&
      this.state.questions?.length > 0 &&
      !this.state.activePartId
    ) {
      this.generateGroupedQuestions();
    }
    this.setState({ examViewLoading: false });
    if (this.props.sections && this.props.sections.length > 0) {
      this.onClickViewAllQuestions();
    }

    let fetchRestartPauseStatus = await this.props.fetchRestartPauseStatus(this.props.assessment.assessment_id);
    this.setState({ is_restart: fetchRestartPauseStatus?.is_restart, is_pause: fetchRestartPauseStatus?.is_pause, pause_until: fetchRestartPauseStatus?.pause_until });

  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.questions !== this.state.questions && this.state.questions.length > 0) {
      this.questionRefs = this.state.questions.map(() => React.createRef());
    }

    if (this.state.submissionState) {
      if (!this.props.submission_uploading && this.props.submission_error) {
        window.Swal.fire({
          title: namespace.FAILED,
          text: namespace.ANSWER_SAVED_FAIL,
          icon: "error",
          customClass: {
            confirmButton: `btn font-weight-bold ${confirmClass}`,
          },
          onOpen: (modalElement) => {
            if (customer === customerConstants.EXO_CUSTOMER2) {
              modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
            }
          }
        }
        );
      } else if (this.props.submission_success) {
        window.Swal.fire({
          title: "",
          text: namespace.ANSWER_SAVED_SUCCESSFULL,
          icon: 'success',
          customClass: {
            confirmButton: `btn font-weight-bold ${confirmClass}`,
          },
          onOpen: (modalElement) => {
            if (customer === customerConstants.EXO_CUSTOMER2) {
              modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
            }
          }
        }
        );
      }
      this.setState({ submissionState: false });
    }

    // Reload answers if exam is resumed
    if (
      this.state.questions &&
      this.state.questions.length &&
      this.props.questionContents.length &&
      !this.state.setAnswers
    ) {
      var ques = [...this.state.questions];
      let subQuestions = {}
      let answeredQuestions = [...this.state.answeredQuestions]
      let selectedAnswers = this.state.answers;
      var num = 0;
      this.props.questions.map((question, i) => {
        if (this.props.answerMap[this.props.questions[i].question_id]) {
          var answer =
            this.props.answerMap[this.props.questions[i].question_id];
          if (
            this.props.questions[i]?.question_type === questionTypeConstants.MCQ.name
          ) {
            var answers = JSON.parse(answer);
            selectedAnswers[this.props.questions[i].question_id] = answers;
            if (answer != "[]") {
              answeredQuestions = [...answeredQuestions, this.props.questions[i].question_id]
            }
            if (
              localStorage.getItem(this.props.candidate_id) != null &&
              localStorage.getItem(this.props.candidate_id).includes(i)
            ) {
              this.props.questions[i].needToRevise = true;
              num = num + 1;
              this.state.revisedQuestions.push(i);
            }
          } else if (
            this.props.questions[i]?.question_type ===
            questionTypeConstants.DESCRIPTIVE.name
          ) {


            const q = this.props.questions[i];
            let parsedAnswer = JSON.parse(answer);
            const { textPart, fileParts, isHybrid } = this.getAnswerParts(parsedAnswer);

            // -------- HYBRID DETECTION --------
            if (isHybrid) {
              selectedAnswers[q.question_id] = fileParts;
            }

            // -------- FILE-ONLY FORMAT --------
            else if (Array.isArray(parsedAnswer)) {
              selectedAnswers[q.question_id] = parsedAnswer;
            }

            // -------- TYPED-ONLY FORMAT --------
            else if (parsedAnswer?.blocks) {
              this.setQuestionAnswer(ques, q.question_id, parsedAnswer);
              selectedAnswers[q.question_id] = [];
            }

            // Restore typed part (for hybrid)
            if (textPart) {
              this.setQuestionAnswer(ques, q.question_id, textPart);
            }

            if (this.hasAnswerContent(parsedAnswer, textPart, fileParts)) {
              answeredQuestions = [...answeredQuestions, q.question_id];
            }

            if (
              localStorage.getItem(this.props.candidate_id) != null &&
              localStorage.getItem(this.props.candidate_id).includes(i)
            ) {
              q.needToRevise = true;
              num = num + 1;
              this.state.revisedQuestions.push(i);
            }


          } else if (
            (this.props.questions[i]?.question_type ===
              questionTypeConstants.SUBQUESTION.name) && !this.props.questions[i]?.is_subquestion
          ) {

            let subQuestionIdArray = this.props.questions[i]?.sub_questions?.split(',')

            let subQuesAns = subQuestionIdArray.map(id => {

              let answerRaw = this.props.answerMap[id];
              let answerState;
              let fileParts = [];
              let parsed;

              if (answerRaw) {

                parsed = JSON.parse(answerRaw);

                // -------- HYBRID DETECTION --------
                if (Array.isArray(parsed) && parsed.length > 0 && parsed[0]?.part_type) {

                  parsed.forEach(part => {
                    if (part.part_type === "text") {
                      answerState = EditorState.createWithContent(
                        convertFromRaw(part.value)
                      );
                    }
                    if (part.part_type === "file") {
                      fileParts.push(part.blob);
                    }
                  });

                } else {
                  answerState = EditorState.createWithContent(
                    convertFromRaw(parsed)
                  );
                }

              } else {
                answerState = EditorState.createWithContent(
                  ContentState.createFromText('')
                )
              }

              // restore file answers if exist
              if (fileParts.length > 0) {
                selectedAnswers[id] = fileParts;
              }

              return {
                answerId: parseInt(id),
                answer: answerState
              }
            });

            const categorizedQuestionIndex = ques.findIndex(
              item => item.question_id === this.props.questions[i]?.question_id
            );

            if (categorizedQuestionIndex !== -1) {
              ques[categorizedQuestionIndex]['answer'] = subQuesAns
            }

            let isAnswered = false;
            subQuestions = { ...this.state.subQuestions }

            subQuesAns.forEach(ans => {

              let subQuesIndex = Object.keys(subQuestions)
                .find(ques => subQuestions[ques].question_id === ans.answerId)

              if (subQuesIndex) {
                subQuestions[subQuesIndex]['answer'] = ans.answer ? ans.answer : ''
              }

              if (!!ans['answer']?.getCurrentContent().getPlainText().length) {
                isAnswered = true
              }
            })

            if (isAnswered) {
              answeredQuestions = [...answeredQuestions, this.props.questions[i].question_id]
            }

            if (
              localStorage.getItem(this.props.candidate_id) != null &&
              localStorage.getItem(this.props.candidate_id).includes(i)
            ) {
              this.props.questions[i].needToRevise = true;
              num = num + 1;
              this.state.revisedQuestions.push(i);
            }
          } else if (
            this.props.questions[i].question_type === questionTypeConstants.SUBMISSION.name
          ) {
            const q = this.props.questions[i];
            let parsedAnswer = JSON.parse(answer);
            const { textPart, fileParts, isHybrid } = this.getAnswerParts(parsedAnswer);

            // -------- HYBRID FORMAT --------
            if (isHybrid) {
              selectedAnswers[q.question_id] = fileParts;
            }

            // --------FILE-ONLY FORMAT --------
            else if (Array.isArray(parsedAnswer)) {
              selectedAnswers[q.question_id] = parsedAnswer;
            }

            // -------- TYPED-ONLY FORMAT --------
            else if (parsedAnswer?.blocks) {
              this.setQuestionAnswer(ques, q.question_id, parsedAnswer);
              selectedAnswers[q.question_id] = [];
            }

            // Restore typed part (for hybrid)
            if (textPart) {
              this.setQuestionAnswer(ques, q.question_id, textPart);
            }

            if (this.hasAnswerContent(parsedAnswer, textPart, fileParts)) {
              answeredQuestions = [...answeredQuestions, q.question_id];
            }

            if (
              localStorage.getItem(this.props.candidate_id) != null &&
              localStorage.getItem(this.props.candidate_id).includes(i)
            ) {
              this.props.questions[i].needToRevise = true;
              num = num + 1;
              this.state.revisedQuestions.push(i);
            }
          }

          this.setState({
            subQuestions: subQuestions,
          });
        }
      });
      this.setState({
        questions: ques,
        setAnswers: true,
        answers: selectedAnswers,
        needToRevise: num,
        answeredQuestions
      });
    }

    const questionsChanged = JSON.stringify(prevProps.questions) !== JSON.stringify(this.props.questions);
    const sectionsChanged = JSON.stringify(prevProps.sections) !== JSON.stringify(this.props.sections);

    if ((questionsChanged || sectionsChanged) && this.state.questions?.length > 0) {
      this.generateGroupedQuestions();
    }

    if (!prevProps.sections && this.props.sections && this.props.sections > 0) {
      this.onClickViewAllQuestions();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onUnload);
    clearInterval(this.intervalID);
    this.autosaveTestState()
  }

  generateGroupedQuestions = () => {
    const subQuestions = {};
    const indexes = this.state.subQuestionsIndexes || [];

    indexes.forEach(index => {
      if (this.props.questionContents.hasOwnProperty(index)) {
        subQuestions[index] = this.props.questionContents[index];
      }
    });

    const filteredQuestions = this.props.questionContents.filter(
      (item, index) => !indexes.includes(index)
    );

    const groupedQuestions = {};
    filteredQuestions.forEach((rawContent, i) => {
      const question = this.state.questions[i];
      if (!question) return;

      const { section_id } = question;
      const sectionMeta = this.props.sections.find(
        s => s.section_id === section_id
      );

      const section_title = sectionMeta?.section_title || 'Untitled Section';
      const part_name = sectionMeta?.part_name || 'Unnamed Part';
      const allow_part_instruction = sectionMeta?.allow_part_instruction ?? false;
      const part_instruction = sectionMeta?.part_instruction ?? '';
      const allow_section_instruction = sectionMeta?.allow_section_instruction ?? false;
      const section_instruction = sectionMeta?.section_instruction ?? '';
      const part_id = sectionMeta?.part_id;
      const part_display_order = sectionMeta?.part_display_order ?? 0;
      const section_display_order = sectionMeta?.section_display_order ?? 0;

      if (!groupedQuestions[part_id]) {
        groupedQuestions[part_id] = {
          name: part_name,
          allow_part_instruction,
          part_instruction,
          part_display_order,
          sections: {},
        };
      }

      if (!groupedQuestions[part_id].sections[section_id]) {
        groupedQuestions[part_id].sections[section_id] = {
          title: section_title,
          allow_section_instruction,
          section_instruction,
          section_display_order,
          questions: [],
        };
      }

      groupedQuestions[part_id].sections[section_id].questions.push({
        rawContent,
        question,
        index: i,
      });
    });

    // Sort parts and sections
    const sortedParts = Object.entries(groupedQuestions)
      .sort(([, a], [, b]) => a.part_display_order - b.part_display_order);

    // First partId according to sorted order
    const firstPartEntry = sortedParts[0];
    const firstPartId = firstPartEntry ? firstPartEntry[0] : null;
    const firstPart = firstPartEntry ? firstPartEntry[1] : null;

    // Sort sections inside each part and get first sectionId from first part
    let firstSectionId = null;
    sortedParts.forEach(([partId, part]) => {
      const sortedSections = Object.entries(part.sections)
        .sort(([, a], [, b]) => a.section_display_order - b.section_display_order);

      // Update section order
      const newSectionObj = {};
      sortedSections.forEach(([sectionId, section]) => {
        newSectionObj[sectionId] = section;
        if (partId === firstPartId && !firstSectionId) {
          firstSectionId = sectionId;
        }
      });

      groupedQuestions[partId].sections = newSectionObj;
    });

    // Set state with correct active part and section according to display_order
    this.setState({
      activePartId: firstPartId,
      activeSectionId: firstSectionId,
      groupedQuestions: groupedQuestions,
    });

    // Create refs in sorted order
    sortedParts.forEach(([partId, part]) => {
      this.partRefs[partId] = React.createRef();
      Object.keys(part.sections).forEach(sectionId => {
        this.sectionRefs[sectionId] = React.createRef();
      });
    });
  };

  onClickViewAllQuestions = () => {
    if (this.props.sections && this.props.sections.length > 0) {
      this.setState({ viewAllQuestions: true });
    } else {
      this.setState((prevState) => ({
        viewAllQuestions: !prevState.viewAllQuestions,
      }));
    }
  }

  autosaveTestState() {
    this.saveTestState();
  }

  onSelectQus = (index) => {
    this.setState({ currentQuestion: index, highlightedQuestion: index, currentQuestionIndex: index }, () => {
      const questionElement = this.questionRefs[index]?.current;
      if (this.state.viewAllQuestions && questionElement) {
        const questionRect = questionElement.getBoundingClientRect();
        const containerRect = this.containerRef.current.getBoundingClientRect();
        const scrollTop = this.containerRef.current.scrollTop + (questionRect.top - containerRect.top);
        this.containerRef.current.scrollTo({
          top: scrollTop,
          behavior: 'smooth',
        });
      }
    });
  };

  //onclick event of make revise button
  makeRevise = (e, questionIndex) => {
    let num = this.state.needToRevise;
    const ques = [...this.state.questions];
    ques[questionIndex].needToRevise = e.target.checked;
    this.setState({ questions: ques });
    if (e.target.checked) {
      this.setState({ needToRevise: num + 1 });
      this.state.revisedQuestions.push(questionIndex);
    } else {
      this.setState({ needToRevise: num - 1 });
      this.state.revisedQuestions.splice(
        this.state.revisedQuestions.indexOf(questionIndex),
        1
      );
    }
    localStorage.setItem(this.props.candidate_id, this.state.revisedQuestions);
  }

  //When Candidate write answers for Descriptive Questions
  makeEdit = (editorState, questionIndex, questionId) => {
    const contentState = editorState.getCurrentContent();
    const plainText = contentState.getPlainText();
    const ques = [...this.state.questions];
    ques[questionIndex].answer = editorState;
    this.setState({ questions: ques });

    if (!this.state.answeredQuestions.includes(questionId)) {
      this.setState({
        answeredQuestions: [...this.state.answeredQuestions, questionId]
      }, () => {
        if (!ques[questionIndex].answer.getCurrentContent().getPlainText().length) {
          let removedArray = this.state.answeredQuestions.filter(item => item !== questionId)
          this.setState({
            answeredQuestions: [...removedArray]
          })
        }
      })
    } else {
      if (!ques[questionIndex].answer.getCurrentContent().getPlainText().length) {
        let removedArray = this.state.answeredQuestions.filter(item => item !== questionId)
        this.setState({
          answeredQuestions: [...removedArray]
        })
      }
    }
  }

  makeSubQuestionEdit = (editorState, questionIndex, questionId) => {
    const ques = { ...this.state.subQuestions };
    ques[questionIndex].answer = editorState;
    const setAnswerQuestion = () => {
      let isAnswered = false
      for (const key in ques) {
        if (!!ques[key].answer?.getCurrentContent().getPlainText().length) {
          isAnswered = true
        }
      }
      if (!isAnswered) {
        let removedArray = this.state.answeredQuestions.filter(item => item !== questionId)
        this.setState({
          answeredQuestions: [...removedArray]
        })
      }
    }
    this.setState({ subQuestions: ques });
    if (!this.state.answeredQuestions.includes(questionId)) {
      this.setState({
        answeredQuestions: [...this.state.answeredQuestions, questionId]
      }, () => {
        setAnswerQuestion()
      })
    } else {
      setAnswerQuestion()
    }
  }

  //onclick event of previous button
  onClickPrevious() {
    let previousQus = this.state.currentQuestion;
    if (this.state.currentQuestion > 0) {
      this.setState({ currentQuestion: previousQus - 1 });
    }
  }

  //onClick event of next button
  onClickNext() {
    let previousQus = this.state.currentQuestion;
    if (this.state.questions.length - 1 > this.state.currentQuestion) {
      this.setState({ currentQuestion: previousQus + 1 });
    }
  }

  onClickPreviousPart = () => {
    const { partIds, activePartId } = this.state;
    if (!partIds || partIds.length === 0 || !activePartId) return;

    const currentIndex = partIds.indexOf(activePartId);
    if (currentIndex === -1 || currentIndex <= 0) return;

    const prevPartId = partIds[currentIndex - 1];
    this.goToPart(prevPartId);
  };

  onClickNextPart = () => {
    const { partIds, activePartId } = this.state;
    if (!partIds || partIds.length === 0 || !activePartId) return;

    const currentIndex = partIds.indexOf(activePartId);
    if (currentIndex === -1) return;

    if (currentIndex < partIds.length - 1) {
      const nextPartId = partIds[currentIndex + 1];
      this.goToPart(nextPartId);
    }
  };

  goToPart = (partId) => {
    const groupedQuestions = this.state.groupedQuestions;
    if (!groupedQuestions[partId]) return;

    const firstSectionId = Object.keys(groupedQuestions[partId].sections)[0];
    const firstQuestion = groupedQuestions[partId].sections[firstSectionId].questions[0];

    this.setState({
      activePartId: partId,
      activeSectionId: firstSectionId,
      currentQuestion: firstQuestion.index,
      highlightedQuestion: firstQuestion.index,
    });
  }

  //when candidate select answer for MCQ question
  markAnswer = (e, questionIndex, answerIndex) => {
    let selectedAnswers = { ...this.state.answers };
    let current = selectedAnswers[questionIndex];
    let index;

    if (!current) {
      selectedAnswers[questionIndex] = [];
    }
    index = selectedAnswers[questionIndex]?.indexOf(answerIndex);

    if (index !== -1) {
      selectedAnswers[questionIndex].splice(index, 1);
    } else {
      selectedAnswers[questionIndex].push(answerIndex);
    }

    this.setState({
      answers: selectedAnswers,
    }, () => {
      if (this.state.answeredQuestions.includes(questionIndex) && (selectedAnswers[questionIndex]?.length === 0)) {
        let removedArray = this.state.answeredQuestions.filter(item => item !== questionIndex)
        this.setState({
          answeredQuestions: [...removedArray]
        })
      }
    });

    if (!this.state.answeredQuestions.includes(questionIndex)) {
      this.setState({
        answeredQuestions: [...this.state.answeredQuestions, questionIndex]
      })
    }
  }

  //when candidate select only one answer for MCQ question
  markOneAnswer = (e, questionIndex, answerIndex) => {
    const selectedAnswers = { ...this.state.answers };

    selectedAnswers[questionIndex] = [answerIndex];

    this.setState(
      {
        answers: selectedAnswers,
      },
      () => {
        if (!this.state.answeredQuestions.includes(questionIndex)) {
          this.setState((prevState) => ({
            answeredQuestions: [...prevState.answeredQuestions, questionIndex],
          }));
        }
      }
    );
  }

  async saveTestState() {
    let candidate_id = this.props?.candidate_id;
    let assessment_id = this.props?.assessment.assessment_id;
    let attempt_no = this.props?.candidateAssessment.attempt_no;
    let sub_questions = this.state.subQuestions

    // let attempt_no = 
    let question_id, contentState, answer_content;
    let answers = {},
      i;
    for (i = 0; i < this.state?.questions.length; i++) {
      question_id = this.state.questions[i].question_id;
      answers[question_id] = [];
      if (this.state.questions[i].question_type === questionTypeConstants.MCQ.name) {
        if (this.state.answers[question_id]) {
          answers[question_id] = this.state.answers[question_id];
        } else {
          answers[question_id] = [];
        }
      }
      else if (
        this.state.questions[i].question_type ===
        questionTypeConstants.DESCRIPTIVE.name
      ) {


        const q = this.state.questions[i];
        let typedAnswer = null;
        let fileAnswers = this.state.answers?.[question_id] || [];

        // -------- GET TYPED CONTENT --------
        if (q?.answer) {
          const contentState = q.answer.getCurrentContent();
          typedAnswer = convertToRaw(contentState);
        }

        answers[question_id] = this.buildTypedFileAnswer(typedAnswer, fileAnswers);

      } else if (
        this.state.questions[i].question_type ===
        questionTypeConstants.SUBQUESTION.name && this.state.questions[i].is_subquestion !== "true"
      ) {
        answer_content = this.buildEmptyEditorAnswer();
        answers[question_id] = answer_content;
      }


      else if (
        this.state.questions[i].question_type ===
        questionTypeConstants.SUBMISSION.name
      ) {
        const q = this.state.questions[i];
        let typedAnswer = null;
        let fileAnswers = this.state.answers[question_id] || [];

        // -------- GET TYPED CONTENT --------
        if (q?.answer) {
          const contentState = q.answer.getCurrentContent();
          typedAnswer = convertToRaw(contentState);
        }

        answers[question_id] = this.buildTypedFileAnswer(typedAnswer, fileAnswers);

      }



    }

    if (Object.keys(sub_questions).length > 0) {
      for (let val in sub_questions) {

        const subQ = sub_questions[val];
        const subQuestionId = subQ?.question_id;

        let typedAnswer = null;
        let fileAnswers = this.state.answers?.[subQuestionId] || [];

        // -------- TYPED PART --------
        if (subQ?.answer) {
          let contentState = subQ.answer.getCurrentContent();
          typedAnswer = convertToRaw(contentState);
        }

        const subAnswer = this.buildTypedFileAnswer(typedAnswer, fileAnswers);
        if (Array.isArray(subAnswer) && subAnswer.length === 0) {
          answers[subQuestionId] = this.buildEmptyEditorAnswer();
        } else {
          answers[subQuestionId] = subAnswer;
        }
      }
    }

    const examState = { candidate_id, assessment_id, answers, attempt_no }
    sessionStorage.setItem(namespace.EXAMSTATE, JSON.stringify(examState));
    await this.props?.submitAnswers({ ...examState });
    await this.props?.getCandidateAnswers(this.props?.exam);
    await this.props?.getAllCandidateAnswerContents({ answers: this.props?.candidateAnswers });
    //await this.autoGradeMCQ();
  }

  //onclick event of save button, it save or update answer changes to db
  async onClickSave(e) {
    this.setState({ submitLoading: true });
    e.preventDefault();
    await this.saveTestState();
    //await this.autoGradeMCQ();
    this.setState({ submissionState: true });
    this.setState({ submitLoading: false });
  }

  //finish test, it submit answers to db and change candidate status as finished in db
  async handleSubmitTest() {
    window.removeEventListener("beforeunload", this.onUnload);
    this.setState({ submitLoading: true });
    this.setState({
      submit: true,
      isSubmitModalVisible: false
    });
    await this.saveTestState();
    await this.checkingForAllMcqs();
    if (this.state.isAllMCQs) {
      await this.autoGradeMCQ();
    }
    let candidate_id = this.props.candidate_id;
    let is_all_mcq = this.state.isAllMCQs;
    this.props.finishTest({ candidate_id, is_all_mcq }).then(() => {
      clearInterval(this.intervalID);
      this.setState({ finishState: true }, () => {
        if (!this.props.submission_uploading && this.props.submission_error) {
          window.Swal.fire({
            title: namespace.FAILED,
            text: "Exam Finishing Failed",
            icon: "error",
            customClass: {
              confirmButton: `btn font-weight-bold ${confirmClass}`,
            },
            onOpen: (modalElement) => {
              if (customer === customerConstants.EXO_CUSTOMER2) {
                modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
              }
            }
          });
          this.setState({ finishState: false, timeUp: false, submit: false, renderGradeReport: null });
        } else if (
          !this.props.finish_loading && this.props.finish_success
        ) {
          localStorage.removeItem(this.props.candidate_id);
          window.Swal.fire({
            title: "Submission Complete",
            text: "Exam Finished Successfully",
            icon: "success",
            showConfirmButton: true,
            allowOutsideClick: false,
            customClass: {
              confirmButton: `btn font-weight-bold ${confirmClass}`,
            },
            onOpen: (modalElement) => {
              if (customer === customerConstants.EXO_CUSTOMER2) {
                modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
              }
            }
          }).then((action) => {
            if (action.isConfirmed) {
              this.setState({ showRatingModal: true });
            }
          })

        }
      });
    });
    this.setState({ submitLoading: false })
    sessionStorage.removeItem(namespace.EXAMSTATE)
  }

  handleRatingClose = ({ action, rating }) => {
    
    this.setState({ showRatingModal: false });
    if (action === 'success') {
          if (this.state.isAllMCQs) {
            this.setState({
              renderGradeReport: 'auto',
              submit: false,
            });
            // history.push("/paper-auto-grade-report");
          } else {
            this.setState({
              renderGradeReport: 'normal',
              submit: false,
            });
            // history.push("/paper-grade-report");
          }
        }else {
      // User cancelled rating
      if (this.state.isAllMCQs) {
              this.setState({
                renderGradeReport: 'auto',
                submit: false,
              });
              // history.push("/paper-auto-grade-report");
            } else {
              this.setState({
                renderGradeReport: 'normal',
                submit: false,
              });
              // history.push("/paper-grade-report");
            }
    }
  };

  async getSubmissionContent(file, questionIndex) {
    let answers = { ...this.state.answers }; // copy state
    let files = [];

    // Initialize files array if already present
    if (Array.isArray(this.state.answers[questionIndex]) && this.state.answers[questionIndex] !== "[]") {
      files = [...this.state.answers[questionIndex]];
    }

    // Track answered questions
    if (!this.state.answeredQuestions.includes(questionIndex)) {
      this.setState({
        answeredQuestions: [...this.state.answeredQuestions, questionIndex]
      }, () => {

      });
    }

    const container_id = `${this.props.candidate_id}-${questionIndex}`;
    const container_name = config.storageBlobConfigs.containerName;
    const name = file.upload.filename;
    const size = file.upload.total;
    // const maxFileCount = config.fileUploadConfigs.maxFileCount;
    const maxFileSizeInBytes = config.fileUploadConfigs.maxFileSize * 1024;

    const UploadValidationError = (message) => {
      window.Swal.fire({
        title: 'Failed!',
        text: message,
        icon: 'error',
        customClass: { confirmButton: `btn font-weight-bold ${confirmClass}` }
      });
    };
    
    if (!name || name === "") {
      UploadValidationError("File cannot be uploaded. File name is empty.");
      return;
    }

    // Check for duplicate file names before max count, so duplicates get the right message
    if (files.includes(name) || files.includes('"' + name.replace(/^\[(.+)\]$/, "$1").replace(/"\"$/, "$1") + '"')) {
      UploadValidationError("File cannot be uploaded. A file with the same name already exists.");
      return;
    }

    // if (files.length >= maxFileCount) {
    //   UploadValidationError(`File cannot be uploaded. Maximum ${maxFileCount} file(s) can be uploaded at a time.`);
    //   return;
    // }

    if (size > maxFileSizeInBytes) {
      const maxSizeGB = (maxFileSizeInBytes / (1024 * 1024 * 1024)).toFixed(2);
      UploadValidationError(`File cannot be uploaded. Maximum File Size is ${maxSizeGB} GB.`);
      return;
    }

    // Add file to local state arrays
    files.push(name);
    this.state.filesUploaded.push(name);
    answers[questionIndex] = files;



    try {
      const reader = new FileReader();

      reader.onload = async (e) => {
        const fileData = e.target.result;
        console.log("FileReader load complete for:", name);

        try {
          await AzureStorage.uploadBlob(container_name, `${container_id}-${name}`, fileData);
          console.log("Azure upload complete for:", name);

          window.Swal.fire({
            title: "Success!",
            text: `File ${name} uploaded successfully!`,
            icon: "success",
            customClass: { confirmButton: `btn font-weight-bold ${confirmClass}` }
          });

          // Remove from temporary uploaded files array
          const deletedItem = this.state.filesUploaded.splice(this.state.filesUploaded.indexOf(name), 1);
          console.log("Temporary uploaded files array updated:", this.state.filesUploaded);

          // Update state and save test state AFTER state update
          this.setState({ answers: answers }, () => {
            this.saveTestState();
          });

        } catch (uploadErr) {
          console.error("Error uploading file to Azure:", uploadErr);
          // Rollback files array
          files.pop();
          this.setState({ answers: answers });
        }
      };

      // Read actual file object
      reader.readAsArrayBuffer(file.upload.fileObject);
      console.log("FileReader read initiated for:", name);

    } catch (e) {
      console.error("FileReader initialization failed:", e);
      files.pop();
      this.setState({ answers: answers });
    }
  }


  deleteSubmissionContent(file, questionIndex) {
    let answers = this.state.answers;
    let files = this.state.answers[questionIndex];
    const container_id = "".concat(this.props.candidate_id, "-", questionIndex);
    const container_name = config.storageBlobConfigs.containerName;
    AzureStorage.deleteblob(container_name, container_id + "-" + file.name.replace(/['"]+/g, ""));
    let fileIndex = files.indexOf(file);
    files.splice(fileIndex, 1);
    answers[questionIndex] = files;

    this.saveTestState();
    this.setState({
      answers: answers,
    });
  }



  async onDownloadAttachment(e, container, attach) {
    e.preventDefault();
    try {
      let fileReader;
      async function handleFileRead() {
        const content = fileReader.result;
      }

      fileReader = new FileReader();
      fileReader.onloadend = handleFileRead;
      let content = await AzureStorage.downloadBlob(container, attach);
      fileReader.readAsArrayBuffer(content);
      return true;
    } catch (error) {
      return false;
    }
  }

   
  handleAttachFileClick = (inputId) => {
    const el = document.getElementById(inputId);
    if (el) el.click();
  };

  handleFileChange = (e, questionId) => {
    const file = e?.target?.files?.[0];
    if (!file) return;

    const wrappedFile = {
      upload: {
        filename: file.name,
        total: file.size,
        fileObject: file,
      },
    };

    this.getSubmissionContent(wrappedFile, questionId);

    // reset input so same file can be re-uploaded
    if (e?.target) e.target.value = null;
  };

  handleFileDownload = async (e, questionId, filename) => {
    if (e?.preventDefault) e.preventDefault();

    const candidateId = this.props?.candidate_id;
    const containerName = config?.storageBlobConfigs?.containerName;

    if (!this.onDownloadAttachment || !candidateId || !containerName) return;

    const container = `${candidateId}-${questionId}`;
    const cleanFileName = String(filename || "").replace(/['"]+/g, "").trim();
    const blobName = `${container}-${cleanFileName}`;

    try {
      await this.onDownloadAttachment(e, containerName, blobName);
    } catch (err) {
      window.Swal.fire({
        title: "Failed",
        text: "Unable to download file. The file may not exist in storage.",
        icon: "error",
      });
    }
  };

  handleFileDelete = (file, questionId) => {
    if (!this.deleteSubmissionContent) return;

    // normalize to object with .name
    const normalizedFile =
      typeof file === "string"
        ? { name: file }
        : file?.upload?.filename
          ? { name: file.upload.filename }
          : file?.name
            ? file
            : null;

    if (!normalizedFile) return;

    this.deleteSubmissionContent(normalizedFile, questionId);
  };

  changeRoute() {
    // window.location = 'http://localhost:3002/infinity/available-assessments'
    // this.props.history.push({
    //   pathname: routes.enrolled_paper_list,
    //   state: { 
    //     "mid": sessionStorage.getItem("enrolled_paper_list_mid"),
    //     "pid": sessionStorage.getItem("pid"),
    //     "lg_user_id": sessionStorage.getItem("lg_user_id"),
    //     "lg_user_table_id": sessionStorage.getItem("lg_user_table_id"),
    //     "flg_list_active": sessionStorage.getItem("flg_list_active"),
    //     "form_display_title": sessionStorage.getItem("form_display_title"),
    //     "form_list_id": sessionStorage.getItem("form_list_id")
    //   },
    // });
    this.props.offStartExam()
    window.location.reload();
  }

  // checking whether all questions are MCQS or not
  async checkingForAllMcqs() {
    var question_list = this.state.assessmentQuestions,
      i;
    for (i = 0; i < this.state?.assessmentQuestions.length; i++) {
      if (question_list[i]["question_type"] !== questionTypeConstants.MCQ.name) {
        this.setState({ isAllMCQs: false });
      }
    }
    return;
  }

  calculateTotalAllocatedMarks() {
    var question_list = this.state.assessmentQuestions, i, sum = 0;
    for (i = 0; i < this.state?.assessmentQuestions.length; i++) {
      sum = sum + question_list[i]["mark_allocation"]
    }
    return sum;
  }

  calculateTotalReceivedMarks() {
    var i, total = 0;
    for (i = 0; i < this.state?.assessmentQuestions?.length; i++) {
      var candidate_answers = store.getState()["testReducer"]["candidateAnswerMap"];
      if (candidate_answers[this.state?.assessmentQuestions[i].question_id]["mark_obtained"]) {
        total = total + candidate_answers[this.state?.assessmentQuestions[i].question_id]["mark_obtained"];
      }
    }
    return total;
  }

  getAllCandidateGradeScales = async () => {
    this.setState({ isTableDataLoading: true });
    await candidateService.getAllGradeScales()
      .then((response) => {
        if (response.success) {
          this.setState({
            candidateGradeScales: response.data.candidate_grade_scales,
            isTableDataLoading: false
          });
        }
        else {
          this.setState({ isTableDataLoading: false });
        }

      })
      .catch(() => {
        this.setState({ isTableDataLoading: false });
      })
  }

  getRemark(percentage) {
    for (const scale of this.state.candidateGradeScales) {
      if (percentage >= scale.min_marks && percentage <= scale.max_marks) {
        return scale.remarks;
      }
    }
    return "Invalid grade percentage";
  }

  getGrade(percentage) {
    for (const scale of this.state.candidateGradeScales) {
      if (percentage >= scale.min_marks && percentage <= scale.max_marks) {
        return scale.grade;
      }
    }
    return "Invalid grade percentage";
  }

  async autoGradeMCQ() {
    var i;
    for (i = 0; i < this.props?.assessmentQuestions.length; i++) {
      if (this.props.assessmentQuestions[i]?.question_type == questionTypeConstants.MCQ.name) {
        var candidate_answer =
          this.props?.answerMap[
          this.props.assessmentQuestions[i]?.question_id
          ];
        if (candidate_answer) {
          candidate_answer = JSON.parse(candidate_answer);
        }
        var res = this.props.answerContents[i]?.toString().split(",");
        let numOfCandidateAnswers = candidate_answer?.length;
        let numOfAnswers = 0;
        for (var m in res) {
          if (res[m] != "Nan" && res[m] != 0) {
            numOfAnswers = numOfAnswers + 1;
          }
        }
        if (numOfCandidateAnswers <= numOfAnswers) {
          var marks = 0, j, ans_index;
          for (j in candidate_answer) {
            ans_index = candidate_answer[j];
            marks = marks + (res[ans_index] *
              this.props.assessmentQuestions[i]?.mark_allocation) /
              100;
          }
          const assessor_id = "root";
          var id = this.props.questions[i]?.question_id;
          await this.props?.onSetMarks({ id, marks, assessor_id });
        }
        else {
          var marks = 0;
          const assessor_id = "root";
          var id = this.props?.questions[i]?.question_id;
          await this.props?.onSetMarks({ id, marks, assessor_id });
        }
      }
    }

    var total = 0;
    for (i = 0; i < this.props?.assessmentQuestions?.length; i++) {
      var candidate_answer =
        this.props?.answerMap[
        this.props?.assessmentQuestions[i]?.question_id
        ];
      if (candidate_answer?.mark_obtained) {
        total = total + candidate_answer?.mark_obtained;
      }
    }

    const totalMarksAllocation = this.calculateTotalAllocatedMarks();
    const finalGrade = this.calculateTotalReceivedMarks();
    const percentage = (finalGrade / totalMarksAllocation) * 100;
    const remark = this.getRemark(percentage)
    const grade = this.getGrade(percentage)

    let contentState = convertFromRaw({
      blocks: [
        {
          key: 'initial',
          text: remark,
          type: 'unstyled',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {}
        }
      ],
      entityMap: {}
    });
    let remarksState = EditorState.createWithContent(contentState);
    this.setState({ remarksEditorState: remarksState })

    const assessment_id = this.props?.assessment?.assessment_id;
    const user_role_id = "CASS" + this.props?.assessment?.created_by;
    const questions = this.props?.candidateAnswers;
    const candidate_id = this.props?.candidate_id;
    const attempt_no = this.props?.candidateAssessment.attempt_no;
    sessionStorage.setItem("candidate_id", candidate_id);
    sessionStorage.setItem("attempt_no", attempt_no);
    const final_grade = parseFloat(finalGrade);
    const total_mark_allocation = parseFloat(totalMarksAllocation);
    const assessor_remarks = convertToRaw(
      this.state.remarksEditorState.getCurrentContent()
    );
    window.Swal.showLoading();

    await this.props?.saveMarks({
      assessment_id,
      questions,
      user_role_id,
      assessor_remarks,
      candidate_id,
      attempt_no
    });

    await this.props?.finalizeAutoGrade({
      candidate_id,
      final_grade,
      user_role_id,
      attempt_no,
      total_mark_allocation,
      grade
    });

    await this.props.getReport({ candidate_id, attempt_no });
    window.Swal.close();

    if (!this.props.gradeLoading && this.props.gradeError) {
      window.Swal.fire({
        title: "Failed!",
        text: "Failed to autograde!",
        icon: "error",
        customClass: {
          confirmButton: `btn font-weight-bold ${confirmClass}`,
        },
        onOpen: (modalElement) => {
          if (customer === customerConstants.EXO_CUSTOMER2) {
            modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
          }
        }
      });
    }
    // else {
    //   window.Swal.fire("Success!", "Autograded successfully!", "success");
    // }

  }

  handleSubmitModal = () => {
    this.setState({ isSubmitModalVisible: false })
  }

  toggleSubmitModal = () => {
    this.setState((prevState) => ({
      isSubmitModalVisible: !prevState.isSubmitModalVisible,
    }))
  }

  getQuestionPassageContent = (content) => {
    let states = JSON.parse(content);
    let passageContentState = EditorState.createWithContent(convertFromRaw(states[0]));
    return passageContentState;
  }

  // Unified navigation click handler
  handleNavigationClick = ({ partId, sectionId, questionIndex = null }) => {
    const questionKey = questionIndex !== null ? `${sectionId}-${questionIndex}` : null;

    this.setState({
      activePartId: partId ?? this.state.activePartId,
      activeSectionId: sectionId ?? this.state.activeSectionId,
      highlightedQuestion: questionKey,
      currentQuestionIndex: questionIndex,
    }, () => {
      let scrollTarget = null;

      if (questionKey !== null && this.questionRefs[questionKey]?.current) {
        scrollTarget = this.questionRefs[questionKey].current;
      } else if (sectionId && this.sectionRefs[sectionId]?.current) {
        scrollTarget = this.sectionRefs[sectionId].current;
      } else if (partId && this.partRefs[partId]?.current) {
        scrollTarget = this.partRefs[partId].current;
      }

      if (scrollTarget && this.containerRef?.current) {
        const targetRect = scrollTarget.getBoundingClientRect();
        const containerRect = this.containerRef.current.getBoundingClientRect();
        const scrollTop = this.containerRef.current.scrollTop + (targetRect.top - containerRect.top);
        this.containerRef.current.scrollTo({
          top: scrollTop,
          behavior: 'smooth',
        });
      }
    });
  };

  render() {
    let question_content;
    let navPills; //navigate questions button
    let time_difference = null;
    const { isSubmitModalVisible, groupedQuestions } = this.state

    //start exam timer
    if (this.props.start_time) {
      if (this.props.candidate_exam_duration !== null) {
        var start = new Date(Date.parse(this.props.start_time));
        var now = new Date().getTime();
        start.setTime(start.getTime() + this.props.candidate_exam_duration * 60 * 1000);
        if (start >= now) {
          time_difference = start - now;
        } else {
          time_difference = 0;
        }
      }
    }

    if (!this.props.start_time) {
      // return  <Alert className="alert alert-custom alert-danger fade show" alertIcon="flaticon-warning" alertText="Click Here to go to the Available Assessment" onClick={this.changeRoute}/>
      // this.props.history.push({
      //   pathname: routes.enrolled_paper_list,
      //   state: { 
      //     "mid": sessionStorage.getItem("enrolled_paper_list_mid"),
      //     "pid": sessionStorage.getItem("pid"),
      //     "lg_user_id": sessionStorage.getItem("lg_user_id"),
      //     "lg_user_table_id": sessionStorage.getItem("lg_user_table_id"),
      //     "flg_list_active": sessionStorage.getItem("flg_list_active"),
      //     "form_display_title": sessionStorage.getItem("form_display_title"),
      //     "form_list_id": sessionStorage.getItem("form_list_id")
      //   },
      // });
      // window.location.reload();

      this.props.offStartExam()
      //window.location.reload();
    }

    let n = 0; //answered descriptive questions number

    //when candidate enter answer for descriptive question this will add 1 number n=n+1
    if (this.state.questions?.length > 0) {
      this.state.questions.map((qus) => {
        if (qus.answer) {
          return (n = n + 1);
        }
      });
    }

    if (this.state.renderGradeReport === 'auto') {
      return <PaperAutoGradeReport offStartExam={() => this.props.offStartExam()} candidate={this.props.candidate} assessment={this.props.assessment} report={this.props.report} title={this.props.assessment?.title} candidate_id={this.props.candidate_id} allUnits={this.props.allUnits} />
    } else if (this.state.renderGradeReport === 'normal') {
      return <PaperGradeReport offViewReport={() => this.props.offStartExam()} assessment={this.props.assessment} report={this.props.report} title={this.props.assessment?.title} candidate_id={this.props.candidate_id} allUnits={this.props.allUnits} />
    }

    //when time difference becomes 0 then this will invoke handlesubmit test function
    if (this.props.candidate_exam_time_limit === true) {
      if (
        time_difference === 0 &&
        this.state.timeUp == false &&
        this.state.submit == false &&
        window.navigator.onLine == true
      ) {
        this.setState({
          timeUp: true,
        });
        window.Swal.fire({
          title: namespace.WARNING,
          text: "Exam Time Finished",
          icon: "warning",
          showConfirmButton: true,
          allowOutsideClick: false,
          customClass: {
            confirmButton: `btn font-weight-bold ${confirmClass}`,
          },
          onOpen: (modalElement) => {
            if (customer === customerConstants.EXO_CUSTOMER2) {
              modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
            }
          }
        }).then((action) => {
          if (action.isConfirmed) {
            this.handleSubmitTest();
          }
        });
      } else if (
        time_difference === 0 &&
        this.state.timeUp == false &&
        this.state.submit == false &&
        window.navigator.onLine == false
      ) {
        window.Swal.fire({
          title: namespace.WARNING,
          text: "Network disconnected. Please get connected as soon as possible",
          icon: "warning",
          customClass: {
            confirmButton: `btn font-weight-bold ${confirmClass}`,
          },
          onOpen: (modalElement) => {
            if (customer === customerConstants.EXO_CUSTOMER2) {
              modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
            }
          }
        }
        );
      }
    }

    const hasSections = this.props?.sections?.length > 0;

    if (this.state.questions?.length && !hasSections) {
      const subQuestions = {};
      const indexes = this.state.subQuestionsIndexes;

      // Extract subquestion contents
      indexes.forEach(index => {
        if (this.props.questionContents.hasOwnProperty(index)) {
          subQuestions[index] = this.props.questionContents[index];
        }
      });

      // Filter out subquestions from main question content
      const filteredQuestions = this.props.questionContents.filter((item, index) => !indexes.includes(index));

      navPills = (
        <div className="sidebar-question-grid">
          {this.state.questions.map((item, i) => {
            const isCurrent = this.state.highlightedQuestion === i;
            const needToRevise = item.needToRevise;
            const isAnswered = this.state.answeredQuestions.includes(item.question_id);

            let btnClass = "sidebar-qnum-btn";
            if (isCurrent) btnClass += " qnum-current";
            else if (needToRevise) btnClass += " qnum-reviewed";
            else if (isAnswered) btnClass += " qnum-answered";
            else btnClass += " qnum-other";

            return (
              <button
                key={i}
                type="button"
                className={btnClass}
                onClick={() => this.onSelectQus(i)}
              >
                {i + 1}
              </button>
            );
          })}
        </div>
      );

      question_content = filteredQuestions.map((rawContent, i) => {
        let states;
        try {
          states = JSON.parse(rawContent);
        } catch (e) {
          console.error("Failed to parse content for question", i, e);
          return null;
        }

        const tempQuestionState = EditorState.createWithContent(convertFromRaw(states[0]));
        const tempAnswerStates = states.slice(1).map((s) => EditorState.createWithContent(convertFromRaw(s)));

        const question = this.state.questions[i];
        const submissionAnswerMode = this.getsubmissionAnswerMode(question);
        return (
          <QuestionRenderer
            key={i}
            index={i}
            qIndex={i}
            question={question}
            answer={question.answer}
            answers={this.state.answers}
            tempQuestionState={tempQuestionState}
            tempAnswerStates={tempAnswerStates}
            makeRevise={this.makeRevise}
            makeEdit={this.makeEdit}
            markAnswer={this.markAnswer}
            markOneAnswer={this.markOneAnswer}
            getSubmissionContent={this.getSubmissionContent}
            deleteSubmissionContent={this.deleteSubmissionContent}
            getQuestionPassageContent={this.getQuestionPassageContent}
            filesUploaded={this.state.filesUploaded}
            subQuestions={this.state.subQuestions}
            sections={this.props.sections || []}
            onDownloadAttachment={this.onDownloadAttachment}
            candidateId={this.props.candidate_id}
            containerName={config.storageBlobConfigs.containerName}
            submissionAnswerMode={submissionAnswerMode}
            handleAttachFileClick={this.handleAttachFileClick}
            handleFileChange={this.handleFileChange}
            handleFileDownload={this.handleFileDownload}
            handleFileDelete={this.handleFileDelete}
            // onsubmissionAnswerModeChange={(mode) =>
            //   this.handlesubmissionAnswerModeChange(question.question_id, mode)
            // }
            // submissionDropdownOptions={this.state.submissionDropdownOptions}
            renderSubQuestionEditor={() => (
              <SubQuestionRenderer
                mainQuestion={question}
                index={i}
                subQuestions={this.state.subQuestions}
                makeRevise={this.makeRevise}
                makeSubQuestionEdit={this.makeSubQuestionEdit}
                getQuestionPassageContent={this.getQuestionPassageContent}
                sections={this.props.sections || []}
                onDownloadAttachment={this.onDownloadAttachment}
                candidateId={this.props.candidate_id}
                containerName={config.storageBlobConfigs.containerName}
                submissionAnswerMode={this.state.submissionAnswerMode}
                onsubmissionAnswerModeChange={(qid, mode) => this.handlesubmissionAnswerModeChange(qid, mode)}
                getSubmissionContent={this.getSubmissionContent}
                deleteSubmissionContent={this.deleteSubmissionContent}
                answers={this.state.answers}
                handleAttachFileClick={this.handleAttachFileClick}
                handleFileChange={this.handleFileChange}
                handleFileDownload={this.handleFileDownload}
                handleFileDelete={this.handleFileDelete}
                // submissionDropdownOptions={this.state.submissionDropdownOptions}
              />
            )}
          />
        );
      });
    }

    if (this.state.questions?.length > 0 && hasSections) {

      // Set initial active part/section
      if (hasSections && (!this.state.activePartId || !this.state.activeSectionId)) {
        const firstPartId = Object.keys(groupedQuestions)[0];
        const firstSectionId = groupedQuestions[firstPartId] && Object.keys(groupedQuestions[firstPartId].sections)[0];

        if (firstPartId && firstSectionId) {
          setTimeout(() => {
            this.setState({
              activePartId: firstPartId,
              activeSectionId: firstSectionId,
            });
          }, 0);
        }
      }

      // Render navigation tabs
      navPills = (
        <div className="sidebar-navigation">
          {/* Part Pills */}
          <p className="sidebar-nav-label">Navigate to Parts</p>
          <div className="sidebar-pill-group">
            {Object.entries(groupedQuestions).sort(([, a], [, b]) => a.part_display_order - b.part_display_order).map(([partId, part]) => {
              const isActive = this.state.activePartId === partId;
              return (
                <button
                  key={partId}
                  type="button"
                  ref={(el) => (this.partRefs[partId] = el)}
                  className={`sidebar-pill-btn ${isActive ? "active" : ""}`}
                  onClick={() =>
                    this.handleNavigationClick({
                      partId,
                      sectionId: Object.keys(part.sections)[0],
                    })
                  }
                >
                  {part.name}
                </button>
              );
            })}
          </div>

          {/* Section Pills */}
          {this.state.activePartId && groupedQuestions[this.state.activePartId] && (
            <>
              <p className="sidebar-nav-label">Navigate to Sections</p>
              <div className="sidebar-pill-group">
                {Object.entries(groupedQuestions[this.state.activePartId].sections)
                  .sort(([, a], [, b]) => a.section_display_order - b.section_display_order)
                  .map(([sectionId, section]) => {
                    const isActive = this.state.activeSectionId === sectionId;
                    return (
                      <button
                        key={sectionId}
                        type="button"
                        ref={(el) => (this.sectionRefs[sectionId] = el)}
                        className={`sidebar-pill-btn ${isActive ? "active" : ""}`}
                        onClick={() =>
                          this.handleNavigationClick({
                            partId: this.state.activePartId,
                            sectionId,
                          })
                        }
                      >
                        {section.title}
                      </button>
                    );
                  })}
              </div>
            </>
          )}

          {/* Question Number Grid */}
          {this.state.activePartId &&
            this.state.activeSectionId &&
            groupedQuestions[this.state.activePartId]?.sections[this.state.activeSectionId] && (
              <>
                <p className="sidebar-nav-label">Navigate to questions in part</p>
                <div className="sidebar-question-grid">
                  {Object.entries(groupedQuestions[this.state.activePartId].sections)
                    .sort(([, a], [, b]) => a.section_display_order - b.section_display_order)
                    .flatMap(([sectionId, section]) =>
                      section.questions.map(({ question, index }, localIndex) => ({
                        question,
                        index: localIndex,
                        sectionId,
                        key: `${sectionId}-${localIndex}`,
                      }))
                    )
                    .map(({ question, index, sectionId, key }) => {
                      const isCurrent = this.state.highlightedQuestion === key;
                      const isInActiveSection = sectionId === this.state.activeSectionId;
                      const isAnswered = this.state.answeredQuestions.includes(question.question_id);
                      const needToRevise = question.needToRevise;

                      let btnClass = "sidebar-qnum-btn";
                      if (isCurrent) btnClass += " qnum-current";
                      else if (needToRevise) btnClass += " qnum-reviewed";
                      else if (isAnswered) btnClass += " qnum-answered";
                      else if (isInActiveSection) btnClass += " qnum-in-section";
                      else btnClass += " qnum-other";

                      return (
                        <button
                          key={`question-btn-${question.question_id}`}
                          type="button"
                          className={btnClass}
                          title={`Section: ${sectionId}`}
                          onClick={() =>
                            this.handleNavigationClick({
                              partId: this.state.activePartId,
                              sectionId,
                              questionIndex: index,
                              questionKey: key,
                            })
                          }
                        >
                          {index + 1}
                        </button>
                      );
                    })}
                </div>
              </>
            )}
        </div>
      );

      question_content = (
        <>
          {/* Render the Assessment Info Card with metadata */}
          <AssessmentInfoCard details={this.props.assessment_details} />

          {/* Render grouped questions */}
          {Object.entries(groupedQuestions).sort(([, a], [, b]) => a.part_display_order - b.part_display_order).map(([partId, part]) => (
            <div
              key={partId}
              ref={this.partRefs[partId]}
              className={`question-item mb-5 p-4 border border-3 rounded${this.state.activePartId === partId ? " highlighted-part" : ""}`}
            >
              <h2 className="text-primary mb-4">{part.name}</h2>

              {/* Part Instructions */}
              {part.allow_part_instruction && part.part_instruction && (
                <div className="mb-3">
                  <ul className="mb-3" style={{ paddingLeft: '1.5rem' }}>
                    {part.part_instruction.split('\n').map((line, idx) => (
                      <li key={`part-inst-${idx}`}>
                        {line.replace(/^•\s*/, '').trim()}
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {Object.entries(part.sections).sort(([, a], [, b]) => a.section_display_order - b.section_display_order).map(([sectionId, section]) => (
                <div
                  key={sectionId}
                  ref={this.sectionRefs[sectionId]}
                  className={`question-item mb-5${this.state.activeSectionId === sectionId ? " highlighted-section" : ""}`}
                >
                  <h4 className="text-secondary">{section.title}</h4>

                  {/* Section Instructions */}
                  {section.allow_section_instruction && section.section_instruction && (
                    <div className="mb-3">
                      <ul className="mb-3" style={{ paddingLeft: '1.5rem' }}>
                        {section.section_instruction.split('\n').map((line, idx) => (
                          <li key={`section-inst-${idx}`}>
                            {line.replace(/^•\s*/, '').trim()}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  <div className="question-list">
                    {section.questions.map(({ rawContent, question, index }, localIndex) => {
                      let states;
                      try {
                        states = JSON.parse(rawContent);
                      } catch (e) {
                        console.error("Failed to parse content for question", index, e);
                        return null;
                      }

                      const tempQuestionState = EditorState.createWithContent(convertFromRaw(states[0]));
                      const tempAnswerStates = states.slice(1).map(s =>
                        EditorState.createWithContent(convertFromRaw(s))
                      );

                      const key = `${sectionId}-${localIndex}`;
                      this.questionRefs[key] = this.questionRefs[key] || React.createRef();

                      const submissionAnswerMode = this.getsubmissionAnswerMode(question);

                      return (
                        <div
                          key={`question-${sectionId}-${localIndex}`}
                          ref={this.questionRefs[key]}
                          className={`question-item mb-5${this.state.highlightedQuestion === key ? " highlighted-question" : ""}`}
                        >
                          <QuestionRenderer
                            index={localIndex}
                            qIndex={index}
                            question={question}
                            answer={question.answer}
                            answers={this.state.answers}
                            tempQuestionState={tempQuestionState}
                            tempAnswerStates={tempAnswerStates}
                            makeRevise={this.makeRevise}
                            makeEdit={this.makeEdit}
                            markAnswer={this.markAnswer}
                            markOneAnswer={this.markOneAnswer}
                            getSubmissionContent={this.getSubmissionContent}
                            deleteSubmissionContent={this.deleteSubmissionContent}
                            getQuestionPassageContent={this.getQuestionPassageContent}
                            filesUploaded={this.state.filesUploaded}
                            subQuestions={this.state.subQuestions}
                            onDownloadAttachment={this.onDownloadAttachment}
                            candidateId={this.props.candidate_id}
                            containerName={config.storageBlobConfigs.containerName}
                            submissionAnswerMode={submissionAnswerMode}
                            handleAttachFileClick={this.handleAttachFileClick}
                            handleFileChange={this.handleFileChange}
                            handleFileDownload={this.handleFileDownload}
                            handleFileDelete={this.handleFileDelete}
                            // submissionAnswerMode={submissionAnswerMode}
                            // onsubmissionAnswerModeChange={(mode) =>
                            //   this.handlesubmissionAnswerModeChange(question.question_id, mode)
                            // }

                            renderSubQuestionEditor={() => (
                              <SubQuestionRenderer
                                mainQuestion={question}
                                index={localIndex}
                                qIndex={index}
                                subQuestions={this.state.subQuestions}
                                makeRevise={this.makeRevise}
                                makeSubQuestionEdit={this.makeSubQuestionEdit}
                                getQuestionPassageContent={this.getQuestionPassageContent}
                                submissionAnswerMode={this.state.submissionAnswerMode}
                                onsubmissionAnswerModeChange={(qid, mode) => this.handlesubmissionAnswerModeChange(qid, mode)}
                                getSubmissionContent={this.getSubmissionContent}
                                deleteSubmissionContent={this.deleteSubmissionContent}
                                answers={this.state.answers}
                                onDownloadAttachment={this.onDownloadAttachment}
                                candidateId={this.props.candidate_id}
                                containerName={config.storageBlobConfigs.containerName}
                                handleAttachFileClick={this.handleAttachFileClick}
                                handleFileChange={this.handleFileChange}
                                handleFileDownload={this.handleFileDownload}
                                handleFileDelete={this.handleFileDelete}
                              />
                            )}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          ))}
        </>
      );
    }

    const restartExamBtn = this.state.is_restart ? (
      <button
        className="sidebar-restart-btn"
        type="button"
        disabled={!this.props.is_restart}
        onClick={async () => {
          try {
            const result = await window.Swal.fire({
              title: "Are you sure?",
              text: "This will restart your exam and all current progress will be lost.",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
            });
            if (result.isConfirmed) {
              await this.props.restartExam(this.props.candidate_id);
              const candidate_id = this.props?.candidateAssessment?.candidate_id;
              const assessment_id = this.props?.candidateAssessment?.assessment_id;
              const attempt_no = this.props?.candidateAssessment?.attempt_no;
              const answers = this.state.answers;
              const testState = { candidate_id, assessment_id, answers, attempt_no };
              sessionStorage.setItem(namespace.TESTSTATE, JSON.stringify(testState));
              try {
                localStorage.removeItem('examMainTimeRemaining');
                localStorage.removeItem('examPauseTimeRemaining');
              } catch (e) {
                console.warn('Failed to clear exam timer keys from localStorage', e);
              }
              await window.Swal.fire({
                title: "Restarted!",
                text: "Your exam has been restarted.",
                icon: "success",
                confirmButtonText: "OK",
              });
              this.props.offStartExam();
            } else {
              console.log("Restart cancelled");
            }
          } catch (error) {
            console.error("Failed to restart exam:", error);
            await window.Swal.fire({
              title: "Error",
              text: "Could not restart the exam.",
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        }}
      >
        <RestartAltIcon style={{ fontSize: 15, verticalAlign: 'middle', marginRight: 4 }} />
        Restart
      </button>
    ) : null;

    let timer = (
      <div>
        <ExamTimer
          time_int={time_difference}
          is_pause={this.state.is_pause}
          pause_until={this.state.pause_until}
          renderExtra={restartExamBtn ? () => restartExamBtn : undefined}
        />
      </div>
    );
    return (
      <>
        <ContentWrapper>
          {/* {(this.state.timeUp == true ||
          this.state.submit == true ||
          (time_difference == 0 && window.navigator.onLine == false)) && (
          <Spinner id="show" text="Please wait..." />
        )} */}
          {this.props.gradeLoading && <Spinner id="show" text="Please wait.." />}
          {/* {this.state.submit && <Spinner id="show" text="Please wait.." />} */}
          {this.state.submitLoading && <Spinner id="show" text="Please wait.." />}
          {this.state.examViewLoading && <Spinner id="show" text="Please wait.." />}
          {this.props.finish_loading && <Spinner id="show" text="Saving answers.." />}
          {!this.state.showRatingModal &&
          <div>
            <Card>
              <CardBody className={classNames("p-0", { disable_exam: time_difference < 0 })}>
                <div className="row no-gutters exam-page-grid">

                  {/* LEFT COLUMN — col-md-9: header + question area */}
                  <div className="col-md-9 px-0 exam-main-col">

                    {/* Inlined card header: Back button + Assessment title */}
                    <div className="card-header flex-wrap py-2 d-flex align-items-start flex-column align-items-start gap-2 exam-content-header">
                      <Button
                        variant="contained"
                        size="small"
                        className="exam-back-button"
                        onClick={
                          () => {
                            window.Swal.fire({
                              title: namespace.LEAVE_EXAM_WINDOW,
                              text: namespace.LEAVE_WARNING_MESSAGE,
                              showDenyButton: true,
                              showCancelButton: true,
                              icon: "warning",
                              confirmButtonText: namespace.YES,
                              denyButtonText: namespace.NO,
                              customClass: {
                                confirmButton: `btn font-weight-bold ${confirmClass}`,
                              },
                              onOpen: (modalElement) => {
                                if (customer === customerConstants.EXO_CUSTOMER2) {
                                  modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
                                }
                              }
                            }).then(async (result) => {
                              if (result.isConfirmed) {
                                this.props.offStartExam()
                                const candidate_id = this.props?.candidateAssessment?.candidate_id;
                                const assessment_id = this.props?.candidateAssessment?.assessment_id;
                                const attempt_no = this.props?.candidateAssessment?.attempt_no;
                                const answers = this.state.answers;
                                const testState = { candidate_id, assessment_id, answers, attempt_no }
                                sessionStorage.setItem(namespace.TESTSTATE, JSON.stringify(testState));
                              }
                            });
                          }}
                      >
                        Back
                      </Button>
                      <CardTitle
                        cardLabel={this.props.assessment?.title}
                      />
                    </div>

                    {/* Question content area */}
                    <div className="table-wrapper-scroll-y exam-question-area">
                      <ul className="list-unstyled test11">
                        {!this.state.viewAllQuestions &&
                          this.state.questions?.length > 0 ? (
                          <li>
                            <div className="mb-5">
                              {" "}
                              {this.props.questions[this.state.currentQuestion]
                                ? question_content[this.state.currentQuestion]
                                : ""}
                              {/* <h3 className="mb-5 overflow-hidden">{i + 1}. {item.question} */}
                            </div>
                          </li>
                        ) : (
                          // displaying all the questions...
                          !hasSections ?
                            <div ref={this.containerRef} style={{ overflowY: 'scroll', height: '72dvh' }}>
                              {question_content?.length > 0 && question_content.map((content, i) => (
                                <div
                                  key={i}
                                  className={`question-item mb-3 ${this.state.highlightedQuestion === i ? "highlighted" : ""}`}
                                  ref={this.questionRefs[i]}
                                >
                                  {content}
                                </div>
                              ))}
                              {/* {question_content} */}
                            </div> :
                            <div ref={this.containerRef} style={{ overflowY: 'scroll', height: '500px' }}>
                              {question_content}
                            </div>
                        )}
                      </ul>

                      {!hasSections && (
                        <div className={`row justify-content-end paper-btn-container ${this.state.viewAllQuestions ? 'fixed' : ''}`}>
                          <div className="d-flex gap-3 p-4">
                            {!this.state.viewAllQuestions && this.state.currentQuestion > 0 && (
                              <button
                                type="button"
                                className="btn-nav-purple"
                                onClick={this.onClickPrevious}
                              >
                                <ArrowBackIosNewIcon sx={{ fontSize: 18, marginRight: '8px' }} />
                                Previous
                              </button>
                            )}
                            {!this.state.viewAllQuestions &&
                              this.state.questions.length - 1 > this.state.currentQuestion && (
                                <button
                                  type="button"
                                  className="btn-nav-purple"
                                  onClick={this.onClickNext}
                                >
                                  Next
                                  <ArrowForwardIosIcon sx={{ fontSize: 18, marginLeft: '8px' }} />
                                </button>
                              )}
                          </div>
                        </div>
                      )}
                    </div>{/* end exam-question-area */}
                  </div>{/* end exam-main-col (col-md-9) */}

                  {/* RIGHT COLUMN — col-md-3 sidebar */}
                  <div className={`col-md-3 px-0 exam-sidebar-col ${this.props.state.path === "dashboard" ? "dashboardEnrolledPath" : ''}`}>
                    <div className="modern-sidebar">

                      {/* Timer Section */}
                      {this.props.candidate_exam_time_limit === true && (
                        <div className="sidebar-section sidebar-timer-section">
                          <div className="sidebar-timer-box">
                            {(time_difference && timer) || <span className="sidebar-timer-loading">Loading Timer</span>}
                          </div>
                        </div>
                      )}

                      {/* Navigation: Parts / Sections / Question Numbers */}
                      <div className="sidebar-section">
                        {this.state.questions && navPills}
                      </div>

                      {/* Single Page View Toggle */}
                      <div className="sidebar-section">
                        <CardToolbar
                          fnViewAllQuestion={this.onClickViewAllQuestions}
                          isViewAllQuestions={this.state.viewAllQuestions}
                          hasSections={hasSections}
                        />
                      </div>

                      {/* Action Buttons */}
                      <div className="sidebar-action-buttons">
                        <button
                          type="button"
                          className="sidebar-save-btn"
                          onClick={this.onClickSave}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '6px', verticalAlign: 'middle' }}>
                            <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
                            <polyline points="17 21 17 13 7 13 7 21" />
                            <polyline points="7 3 7 8 15 8" />
                          </svg>
                          Save
                        </button>
                        <button
                          type="button"
                          className="sidebar-submit-btn"
                          onClick={this.toggleSubmitModal}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '6px', verticalAlign: 'middle' }}>
                            <polyline points="20 6 9 17 4 12" />
                          </svg>
                          Submit and Finish
                        </button>
                      </div>

                      {/* Stats Row */}
                      <div className="sidebar-stats-row">
                        <div className="sidebar-stat-card">
                          <span className="stat-label">Answered</span>
                          <span className="stat-number stat-answered">{this.state.answeredQuestions.length}</span>
                        </div>
                        <div className="sidebar-stat-card">
                          <span className="stat-label">Unanswered</span>
                          <span className="stat-number stat-unanswered">{this.state.questions.length - this.state.answeredQuestions.length}</span>
                        </div>
                        <div className="sidebar-stat-card">
                          <span className="stat-label">Reviewed</span>
                          <span className="stat-number stat-reviewed">{this.state.needToRevise}</span>
                        </div>
                      </div>

                    </div>
                  </div>{/* end exam-sidebar-col (col-md-3) */}

                </div>{/* end exam-page-grid (row no-gutters) */}
              </CardBody>
            </Card>
          </div>
          }
          {/* Import Questions Modal */}
          <SubmitModal
            // modalTitle="Are you sure you want to finish test?"
            // modalId="import-questions"
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            onHide={() => this.setState({ isSubmitModalVisible: false })}
            show={isSubmitModalVisible}
          >
            <SubmitModal.Header>
              <SubmitModal.Title>Are you sure you want to finish the test?</SubmitModal.Title>
            </SubmitModal.Header>
            <SubmitModal.Body>
              <div className="row mt-10 mb-10">
                <div className="col-lg-4 col-md-4 col-sm-4 col-4">
                  <div className="d-flex flex-column flex-center">
                    <div className="symbol symbol-70 symbol-circle symbol-success overflow-hidden">
                      <span className="symbol-label font-size-h1">
                        {this.state.answeredQuestions.length}
                      </span>
                    </div>
                    <div className="font-weight-bold text-dark-75 mt-4 popup-f-btn">
                      Answered Questions
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-md-4 col-sm-4 col-4">
                  <div className="d-flex flex-column flex-center">
                    <div className="symbol symbol-70 symbol-circle overflow-hidden">
                      <span className="symbol-label font-size-h1">
                        {this.state.questions.length -
                          (this.state.answeredQuestions.length)}
                      </span>
                    </div>
                    <div className="font-weight-bold text-dark-75 mt-4 popup-f-btn">
                      Unanswered Questions
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-md-4 col-sm-4 col-4">
                  <div className="d-flex flex-column flex-center">
                    <div className="symbol symbol-70 symbol-circle symbol-warning overflow-hidden">
                      <span className="symbol-label font-size-h1">
                        {this.state.needToRevise}
                      </span>
                    </div>
                    <div className="font-weight-bold text-dark-75 mt-4 popup-f-btn">
                      Reviewed Questions
                    </div>
                  </div>
                </div>
              </div>
            </SubmitModal.Body>

            <SubmitModal.Footer>
              {/* <Button className="btn btn-outline-primary font-weight-bold btn-lg pr-8 mr-4 popup-f-b-btn" btnName="Review"/> */}
              <QuestionButton
                type="button"
                className={isCMC ? "btn cmc-btn-primary font-weight-bold btn-lg pr-8 mr-4 popup-f-b-btn" : "btn btn-primary font-weight-bold btn-lg pr-8 mr-4 popup-f-b-btn"}
                id="kt_blockui_card_custom_text_2"
                btnName="Submit and Finish Test"
                onClick={this.handleSubmitTest}
              />
              <QuestionButton
                className={isCMC ? "btn cmc-btn-primary font-weight-bold pr-8 btn-lg popup-f-b-btn popup-f-b-close-btn" : "btn btn-light-primary font-weight-bold pr-8 btn-lg popup-f-b-btn popup-f-b-close-btn"}
                dataDismiss="modal"
                btnName="Close"
                onClick={() => this.setState({ isSubmitModalVisible: false })}
              />
            </SubmitModal.Footer>
          </SubmitModal>
        </ContentWrapper>
        {/* Rating modal */}
        {this.state.showRatingModal && (
          <FeedbackAssessment
            onClose={this.handleRatingClose}
            assessmentID={this.props.assessment.assessment_id}
            candidate_id = {this.props?.candidateAssessment?.candidate_id}
          />
        )}
      </>
    );
  }
}

const mapStateToActions = {
  getTestQuestionContent: getTestQuestionContent,
  submitAnswers: submitAnswers,
  getAllQuestionContents: getAllQuestionContents,
  getAllAnswerContents: getAllAnswerContents,
  getCandidateAnswers: getCandidateAnswers,
  getAllCandidateAnswerContents: getAllCandidateAnswerContents,
  refreshAssessmentStartPage: refreshAssessmentStartPage,
  getAutoShuffleFlag: getAutoShuffleFlag,
  loadQuestions: loadQuestions,
  loadAssessmentQuestions: loadAssessmentQuestions,
  finishTest: finishTest,
  onSetMarks: onSetMarks,
  saveMarks: saveMarks,
  finalizeGrade: finalizeGrade,
  finalizeAutoGrade: finalizeAutoGrade,
  getReport: getReport,
  restartExam: restartExam,
  fetchRestartPauseStatus: assessmentActions.get_restart_pause_status_action
};

function mapStateToProps(state) {
  return {
    test_loading: state.testReducer.loading,
    test_error: state.testReducer.error,
    questions: state.testReducer.questions,
    assessmentQuestions: state.testReducer.assessmentQuestions,
    sections: state.testReducer.sections,
    assessment_details: state.testReducer.assessment_details,
    auto_shuffle: state.testReducer.auto_shuffle,

    content_error: state.testPageReducer.error,
    content_success: state.testPageReducer.success,
    content_loading: state.testPageReducer.loading,
    questionContents: state.testPageReducer.questionContents,

    submission_uploading: state.submissionReducer.loading,
    finish_loading: state.submissionReducer.finish_loading,
    submission_error: state.submissionReducer.error,
    submission_success: state.submissionReducer.success,
    finish_success: state.submissionReducer.finish_success,
    finish_error: state.submissionReducer.finish_error,

    assessment: state.validationReducer.assessment,
    candidateAssessment: state.examReducer.assessment,
    exam: state.examReducer.assessment,
    candidate_id: state.validationReducer.candidate_id,
    start_time: state.validationReducer.start_time,
    exam_duration: state.validationReducer.exam_duration,

    candidate_exam_start_time: state.validationReducer.candidate_exam_start_time,
    candidate_exam_duration: state.validationReducer.candidate_exam_duration,
    candidate_exam_buffer_time: state.validationReducer.candidate_exam_buffer_time,
    candidate_exam_time_limit: state.validationReducer.candidate_exam_time_limit,

    answerMap: state.testReducer.candidateAnswerContentMap,
    candidateAnswerContents: state.testReducer.candidateAnswerContents,
    answerContents: state.testReducer.answerContents,
    candidateAnswers: state.testReducer.candidateAnswers,
    candidate: state.testReducer.candidate,

    gradeError: state.gradeReducer.error,
    gradeLoading: state.gradeReducer.loading,

    report: state.examReducer.report,
    is_restart: state.examReducer.is_restart,
    is_pause: state.examReducer.is_pause,
    pause_until: state.examReducer.pause_until,

  };
}

export default connect(mapStateToProps, mapStateToActions)(PaperQuestions);
